import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import MoreIcon from '../../../../../../assets/icons/more.svg';
import CheckIcon from '../../../../../../assets/icons/secondary/Tick Square.svg';
import CameraIcon from '../../../../../../assets/icons/secondary/Video.svg';
import {ms} from '../../../../../../styles/normalizeSize';
import {getColor} from '../../../../../../styles/utils';
import {Clickable} from '../../../../../../uikit/Clickable';
import {Text} from '../../../../../../uikit/Text';
import {View} from '../../../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: row;
  align-items: center;
  padding: ${ms(10)};
  border-radius: ${ms(10)};
  border: 1px solid ${getColor('border2')};
`;

export const IconContainer = styled(View)<StyledProps>`
  width: ${ms(40)};
  min-height: ${ms(40)};
  align-items: center;
  justify-content: center;
  margin-right: ${ms(10)};
  border-radius: ${ms(10)};
  align-self: stretch;

  ${p =>
    p.variant === 'task' &&
    css`
      background-color: ${getColor('background3')};
    `}

  ${p =>
    p.variant === 'conference' &&
    css`
      background-color: ${getColor('background5')};
    `}
`;

const iconStyle = css`
  width: ${ms(24)};
  height: ${ms(24)};
`;

export const TaskIcon = styled(CheckIcon).attrs(p => ({
  fill: getColor('icon4')(p),
}))`
  ${iconStyle};
`;

export const ConferenceIcon = styled(CameraIcon).attrs(p => ({
  fill: getColor('icon5')(p),
}))`
  ${iconStyle};
`;

export const Content = styled(View)`
  flex-direction: column;
  flex: 1;
  padding-right: ${ms(10)};
`;

export const Title = styled(Text).attrs({weight: 'bold'})`
  font-size: ${ms(15)};
  line-height: ${ms(20)};
  letter-spacing: ${ms(-0.47)};
`;

export const LabelsContainer = styled(View)`
  flex-direction: row;
  align-items: center;
`;

export const Label = styled(Text)`
  font-size: ${ms(12)};
  line-height: ${ms(16)};
  letter-spacing: ${ms(-0.41)};
  margin-right: ${ms(6)};
`;

const SMoreIcon = styled(MoreIcon).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
`;

export {SMoreIcon as MoreIcon};

export const MoreIconClickable = styled(Clickable).attrs({
  hitSlop: {
    bottom: 5,
    left: 10,
    right: 10,
    top: 5,
  },
})``;
